"use client";

import { Core } from "@faire/slate/foundation/color";
import { iconCls } from "@faire/slate/lib/tracking";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1756238353493689?thread_ts=1756237700.863289&cid=C08PZGMUC3Z
export const ChevronLeft = createSVGIconV2(
  <path
    d="M16 4L8 12L16 20"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  { displayName: "ChevronLeft", scalingFactor: 125 / 103 },
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.primary,
    className: iconCls(),
  }
);
